import React, { useMemo } from "react";
import { Row, Col, List, Collapse } from "antd";
import { withTranslation } from "react-i18next";
import {
  resolveAlertsListParams,
  getTemperatureRangeLabel,
  getAlertIconClass,
} from "../../utils/shipmentAlertsListUtils";

const { Panel } = Collapse;

function AlertsList({ shipmentCode, alertsListInfo, variant = "full" }) {
  const params = useMemo(
    () => resolveAlertsListParams({ alertsListInfo, shipmentCode, variant }),
    [alertsListInfo, shipmentCode, variant]
  );

  if (params.status === "loading" || params.statusCode !== 200) {
    return <p>{params.message}</p>;
  }

  return (
    <div>
      <Row gutter={16}>
        <Col span={24}>
          <h4>{getTemperatureRangeLabel(params)}</h4>
        </Col>
      </Row>

      <div className="listAlertas">
        <Collapse
          defaultActiveKey={["1"]}
          expandIcon={({ isActive }) => <span>{isActive ? "▼" : "▶"}</span>}
        >
          <Panel header="Listado de alertas" key="0" className="Busca">
            <div className="icon-legend">
              <div className="icon-circle alert-icon">T</div>
              <span className="icon-description"> = Alerta de Temperatura</span>
              <div className="icon-circle warning-icon">T</div>
              <span className="icon-description">
                {" "}
                = Pre-alerta de Temperatura
              </span>
            </div>

            <List
              itemLayout="horizontal"
              dataSource={params.alertsList}
              locale={{ emptyText: "No hay alertas en este rango." }}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      <div
                        className={`icon-circle ${getAlertIconClass(
                          item.class
                        )}`}
                      >
                        T
                      </div>
                    }
                    title={item.date}
                    description={item.message}
                  />
                </List.Item>
              )}
            />
          </Panel>
        </Collapse>
      </div>
    </div>
  );
}

export default withTranslation()(AlertsList);
